function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { firebase } from './../../../utils/firebase/firebase';
import { config } from './../../../conf/config';

import ImageUpload from './../ImageUpload/ImageUpload';
import reportModal from './../ReportModal/ReportModal';

import * as chatroomActions from './../chatroomActions';

export var MessagesList = function (_Component) {
    _inherits(MessagesList, _Component);

    function MessagesList() {
        var _temp, _this, _ret;

        _classCallCheck(this, MessagesList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            showModal: false
        }, _this.changeLastSeenDate = function () {
            var _this$props = _this.props,
                chatroomId = _this$props.chatroomId,
                userId = _this$props.userId,
                isAdmin = _this$props.isAdmin;

            var update = {};
            update['rooms/' + chatroomId + '/lastSeen/' + userId] = new Date().getTime();
            if (isAdmin) {
                update['rooms/' + chatroomId + '/lastSeen/admin'] = new Date().getTime();
            }
            firebase.firebaseApp.database().ref().update(update);
        }, _this.generateHumanDate = function (timeStamp) {
            /*const monthes = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aôut", "Septembre", "Octobre", "Novembre", "Décembre"];
            const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];*/

            var MessageDate = new Date(timeStamp);
            var dateString = MessageDate.getDate() + '/';
            dateString += MessageDate.getMonth() + 1 + '/';
            dateString += MessageDate.getFullYear() + ' ';
            dateString += 'à ' + (MessageDate.getHours() < 10 ? '0' + MessageDate.getHours() : MessageDate.getHours());
            dateString += ':' + (MessageDate.getMinutes() < 10 ? '0' + MessageDate.getMinutes() : MessageDate.getMinutes());
            dateString += ':' + (MessageDate.getSeconds() < 10 ? '0' + MessageDate.getSeconds() : MessageDate.getSeconds());

            return dateString;
        }, _this.handleClick = function (messageId) {
            var _this$props2 = _this.props,
                dispatch = _this$props2.dispatch,
                messages = _this$props2.messages,
                chatroomName = _this$props2.chatroomName;

            if (chatroomName.substr(-3) !== "ask") {
                dispatch(chatroomActions.selectMessage(messageId, messages[messageId]['date']));
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    MessagesList.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var chatroomId = this.props.chatroomId;

        this.scrollToBottom();
        var ref = firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages');
        ref.on('child_added', function (snapshot) {
            var _snapshot$val = snapshot.val(),
                uid = _snapshot$val.uid,
                message = _snapshot$val.message,
                type = _snapshot$val.type,
                createdAt = _snapshot$val.createdAt,
                report = _snapshot$val.report;

            var key = snapshot.key;
            var isReported = typeof report !== 'undefined' ? true : false;
            var isInappropriate = snapshot.val() && snapshot.val().isInappropriate || false;
            _this2.props.dispatch(chatroomActions.retrieveMessage(key, uid, message, type, createdAt, isReported, isInappropriate));
        });
        ref.on('child_changed', function (snapshot) {
            var _snapshot$val2 = snapshot.val(),
                uid = _snapshot$val2.uid,
                message = _snapshot$val2.message,
                type = _snapshot$val2.type,
                createdAt = _snapshot$val2.createdAt,
                report = _snapshot$val2.report,
                isInappropriate = _snapshot$val2.isInappropriate;

            var key = snapshot.key;
            var isReported = typeof report !== 'undefined' ? true : false;
            _this2.props.dispatch(chatroomActions.updateMessage(key, isReported, isInappropriate));
        });
        window.addEventListener('beforeunload', this.changeLastSeenDate);
    };

    MessagesList.prototype.componentDidUpdate = function componentDidUpdate() {
        this.scrollToBottom();
    };

    MessagesList.prototype.componentWillUnmount = function componentWillUnmount() {
        var chatroomId = this.props.chatroomId;

        var ref = firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages');
        ref.off('child_added');
        ref.off('child_changed');
        this.changeLastSeenDate();
        window.removeEventListener('beforeunload', this.changeLastSeenDate);
        this.props.dispatch(chatroomActions.cleanMessages());
    };

    MessagesList.prototype.scrollToBottom = function scrollToBottom() {
        this.el.scrollIntoView({ behavior: 'auto' });
    };

    MessagesList.prototype.render = function render() {
        var _this3 = this;

        var _props = this.props,
            messages = _props.messages,
            users = _props.users,
            userId = _props.userId,
            isAdmin = _props.isAdmin,
            uploadImage = _props.uploadImage;

        return React.createElement(
            'ul',
            { className: 'chats' },
            React.createElement('li', { className: 'hidden-line', ref: function ref(el) {
                    _this3.el = el;
                } }),
            messages.map(function (msg, index) {
                return React.createElement(
                    'li',
                    { className: 'chat ' + (userId === msg.uid ? "right" : "left"),
                        key: msg.key,
                        ref: function ref(el) {
                            _this3.el = el;
                        } },
                    React.createElement(
                        'div',
                        { className: 'picture' },
                        React.createElement('img', { className: 'profilpic', src: config.config[users[msg.uid].avatar], alt: users[msg.uid].username + '\'s profile pic' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'message' + (msg.isReported && !msg.isInappropriate ? " reported" : ""), onClick: _this3.handleClick.bind(_this3, index) },
                        function () {
                            if (msg.type === "text") {
                                return React.createElement(
                                    'div',
                                    null,
                                    React.createElement(
                                        'div',
                                        { className: 'username' },
                                        users[msg.uid].username + (users[msg.uid].isAdmin ? ' de Kids-Matin' : '')
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'messages' + (msg.isInappropriate ? " inappropriate" : "") },
                                        !msg.isInappropriate || isAdmin ? msg.message : "Ce commentaire a été masqué car il ne respectait pas la charte"
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'date' },
                                        _this3.generateHumanDate(msg.date)
                                    )
                                );
                            } else {
                                return React.createElement('img', { src: msg.message, alt: users[msg.uid].username + '\'s pic' });
                            }
                        }()
                    )
                );
            }),
            uploadImage && React.createElement(ImageUpload, null)
        );
    };

    return MessagesList;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        messages: state.chatroom.messages,
        chatroomId: state.chatroom.chatroomId,
        chatroomName: state.chatroom.chatroomName,
        uploadImage: state.chatroom.uploadImage,
        users: state.chatroom.users,
        userId: state.auth.uid,
        isAdmin: state.user.isAdmin
    };
};

export default connect(mapStateToProps)(MessagesList);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/MessagesList/MessagesList.js
// module id = 223
// module chunks = 0